module.exports = __webpack_public_path__ + "static/media/isha.f9c0495f.jpg";